// extracted by mini-css-extract-plugin
export default {"parameter":"SelectInput_parameter__XPQ7t","parameterTitle":"SelectInput_parameterTitle__2NlHa"};